import $ from 'jquery';
import 'waypoints/lib/noframework.waypoints';

export default class Stats {
    constructor() {
        if ($('.js-stats').length) {
            $('.js-stats__stat').each(function() {
                const $this = $(this);

                new Waypoint({
                    element: $this[0],
                    handler: function() {
                        $this.closest('.js-stats__single').addClass('is-active');
                        $this.addClass('is-active');
                    },
                    offset: '75%'
                });
            });
        };
    };
};
